import type { TableColumn } from "./ComparisonTable.types";

export const statusColors: Record<string, string> = {
  ACTIVE: "ACTIVE",
  MAPPED: "ACTIVE",
  MATCHED: "ACTIVE",
  WARNING: "WARNING",
  NEEDS_REVIEW: "WARNING",
  DUPLICATE: "WARNING",
  FAILED: "FAILED",
  NOT_FOUND: "FAILED",
  INACTIVE: "DISABLED",
  UNMATCHED: "DISABLED",
};

export const enumCompatColors: Record<string, string> = {
  OK: "ACTIVE",
  PARTIAL: "WARNING",
  FAILED: "FAILED",
};

export const columnsByType: Record<string, TableColumn[]> = {
  category: [
    { key: "sourceCategory", label: "Source Category", sortable: true },
    { key: "suggestedBase", label: "Suggested Base Category", sortable: true },
    { key: "confidence", label: "Confidence", sortable: true },
    { key: "status", label: "Status", sortable: true },
  ],
  attribute: [
    { key: "sourceAttr", label: "Source Attribute", sortable: true },
    { key: "baseAttr", label: "Base Attribute", sortable: true },
    { key: "confidence", label: "Confidence", sortable: true },
    { key: "enumCompat", label: "Enum Compat", sortable: false },
    { key: "status", label: "Status", sortable: true },
  ],
  sku: [
    { key: "sourceSku", label: "Source SKU", sortable: true },
    { key: "candidateMaster", label: "Candidate Master SKU", sortable: true },
    { key: "matchSignals", label: "Match Signals", sortable: false },
    { key: "status", label: "Status", sortable: true },
  ],
};
